import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Badge"
}
const _hoisted_2 = { class: "RefineContentOptionsList" }
const _hoisted_3 = {
  key: 0,
  class: "Label SelectedLabel"
}
const _hoisted_4 = { class: "LocationList" }
const _hoisted_5 = { class: "LocationList" }
const _hoisted_6 = {
  key: 1,
  class: "Label PopularLabel"
}
const _hoisted_7 = { class: "LocationList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")!
  const _component_CountryCheckbox = _resolveComponent("CountryCheckbox")!
  const _component_AreaFilter = _resolveComponent("AreaFilter")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ 'is-collapsed': _ctx.collapsed })
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "lnr-map-marker FilterIcon" }, null, -1 /* CACHED */)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "Title" }, "Location", -1 /* CACHED */)),
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "Label FilterLabel" }, "Where do you want to study?", -1 /* CACHED */)),
      _createVNode(_component_DropdownFilter, {
        suggest: _ctx.suggest,
        processSelection: _ctx.processSelection,
        lastValidSelectionOption: _ctx.lastValidSelectionOption,
        inputDisplay: _ctx.selectionName,
        filterKey: _ctx.key,
        placeholder: "country, continent or state"
      }, null, 8 /* PROPS */, ["suggest", "processSelection", "lastValidSelectionOption", "inputDisplay", "filterKey"]),
      (_ctx.selectedCountries.length !== 0 || _ctx.selectedContinents.length !== 0 )
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Selected locations"))
        : _createCommentVNode("v-if", true),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCountries, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.optionValue
          }, [
            _createVNode(_component_CountryCheckbox, {
              optionName: item.optionName,
              optionValue: item.optionValue,
              hasAreas: item.hasAreas,
              class: _normalizeClass({ Indented: !item.hasAreas })
            }, null, 8 /* PROPS */, ["optionName", "optionValue", "hasAreas", "class"]),
            (item.hasAreas)
              ? (_openBlock(), _createBlock(_component_AreaFilter, {
                  key: 0,
                  countryId: item.optionValue,
                  onAreaFilterChange: _ctx.processAreaFilterChange
                }, null, 8 /* PROPS */, ["countryId", "onAreaFilterChange"]))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedContinents, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.optionValue
          }, [
            _createVNode(_component_Checkbox, {
              filterKey: _ctx.continentFilterKey,
              optionName: item.optionName,
              optionValue: item.optionValue,
              class: "Indented"
            }, null, 8 /* PROPS */, ["filterKey", "optionName", "optionValue"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      (_ctx.popularCountries.length !== 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Popular locations"))
        : _createCommentVNode("v-if", true),
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularCountries, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.optionValue,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.processCountryCheckboxSelection && _ctx.processCountryCheckboxSelection(...args)))
          }, [
            _createVNode(_component_CountryCheckbox, {
              optionName: item.optionName,
              optionValue: item.optionValue,
              hasAreas: item.hasAreas,
              class: _normalizeClass({ Indented: !item.hasAreas })
            }, null, 8 /* PROPS */, ["optionName", "optionValue", "hasAreas", "class"]),
            (item.hasAreas)
              ? (_openBlock(), _createBlock(_component_AreaFilter, {
                  key: 0,
                  countryId: item.optionValue,
                  onAreaFilterChange: _ctx.processAreaFilterChange
                }, null, 8 /* PROPS */, ["countryId", "onAreaFilterChange"]))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 2 /* CLASS */))
}